module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $o;
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      if (this.collection.persistedCount() < this.totalCount) {
        $o.push("" + $c("<var>" + (this.collection.persistedCount()) + "</var> of "));
      }
      $o.push("" + $c(this.inflector.notranslate_pluralize("total project", this.totalCount)));
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/projects/templates/projects_count.js.hamlc
// module id = 1528
// module chunks = 18